






import Vue from 'vue'
export default Vue.extend({
  props: {
    icon:{
      type:String,required:true
    },
    text:{
      type:String,required:true
    },
    color:{
      type:String,required:true
    }
  }
})
